module.exports = __webpack_public_path__ + "img/tabbar4-1.0bc87e8b.svg";